import {
  Box,
  CircularProgress,
  FormHelperText,
  InputAdornment,
  MenuItem,
} from "@mui/material";
import { UserImage } from "./styles";
import TextField from "@/components/TextField";
import PhoneInput from "@/components/PhoneInput";
import GenderSelect from "@/components/GenderSelect";
import StateSelect from "@/components/StateSelect";
import CitySelect from "@/components/CitySelect";
import Button from "@/components/Button";
import { useProfile } from "./useProfile";
import Dialog from "@/components/Dialog";
import { Gender } from "@/services/auth/types/auth.types";
import CardWithShadow from "@/components/CardWithShadow";

import avatar from "/assets/avatar.png";
import { ProfileImageInput } from "./components/ProfileImageInput";
import DateInput from "@/components/DateInput";
import CpfInput from "@/components/CpfInput";
import CircleCheck from "@/ui/icons/CircleCheck";
import { Tooltip } from "@/components/Tooltip";
import InfoIcon from "@/ui/icons/InfoIcon";
import { TIME_OF_PROFESSION_OPTIONS } from "@/utils/profession.constants";
import { MARITAL_STATUS_OPTIONS } from "@/utils/maritalStatus.constants";
import { FileInput } from "@/components/FileInput";
import { getUploadPostAdvanceDocumentUrl } from "@/services/users";

export default function Profile() {
  const {
    userInfo,
    currentStageNumber,
    isValidStage,
    imageUrl,
    setImageUrl,
    name,
    setName,
    nameError,
    email,
    setEmail,
    phoneNumber,
    phoneNumberError,

    birthDate,
    setBirthDate,
    birthDateError,
    state,
    setState,
    region,
    city,
    setCity,
    professionSelectOptions,
    selectedProfessionName,
    setSelectedProfessionName,
    timeOfProfession,
    setTimeOfProfession,
    instagramAccount,
    setInstagramAccount,
    gender,
    setGender,
    address,
    setAddress,
    numberAddress,
    setNumberAddress,
    complement,
    setComplement,
    neighborhood,
    setNeighborhood,
    cep,
    setCep,
    cepLookupLoading,
    cepLookupHint,
    shirtSize,
    setShirtSize,
    cpf,
    setCpf,
    cpfError,
    phoneNumberResponsible,
    setPhoneNumberResponsible,
    phoneNumberResponsibleError,
    shoeSize,
    setShoeSize,
    pantsSize,
    setPantsSize,
    gloveSize,
    setGloveSize,
    addressProofUrl,
    setAddressProofUrl,
    identityDocumentUrl,
    setIdentityDocumentUrl,
    fatherName,
    setFatherName,
    motherName,
    setMotherName,
    birthPlace,
    setBirthPlace,
    maritalStatus,
    setMaritalStatus,
    rgRne,
    setRgRne,
    rgIssuingAgency,
    setRgIssuingAgency,
    rgIssueDate,
    setRgIssueDate,
    rgIssueDateError,
    isLoading,
    hasChanges,
    onPressCancel,
    onPressSave,
    showChangesDialog,
    toggleChangesDialog,
    showConfirmChangesDialog,
    toggleConfirmDialog,
    showChangesSavedDialog,
    toggleChangesSavedDialog,
    onSaveChanges,
    onCancelChanges,

    isOpenInstagramTooltip,
    toggleTooltip,
  } = useProfile();

  return (
    <CardWithShadow p="1.5rem">
      <Box
        display="flex"
        flex={1}
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
      >
        <Box
          position="relative"
          width="fit-content"
          height="fit-content"
          alignSelf={{ xs: "center", sm: "start" }}
        >
          <ProfileImageInput
            setImageUrl={setImageUrl}
            disabled={currentStageNumber > 1 || !isValidStage}
          />
          <UserImage src={imageUrl || avatar} />
        </Box>

        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          ml={{ xs: "0px", sm: "1rem" }}
        >
          <Box display="flex" flex={1} flexDirection={{ xs: "column", sm: "row" }}>
            <TextField
              label="Nome completo"
              value={name}
              setValue={setName}
              disabled={currentStageNumber > 1 || !isValidStage}
              ContainerProps={{
                mr: { xs: "0px", sm: "1rem" },
                mt: { xs: "1.8rem", sm: "0px" },
                flex: 1,
              }}
              error={!!nameError}
              helperText={nameError}
            />

            <TextField
              label="E-mail"
              value={email}
              setValue={setEmail}
              disabled={currentStageNumber > 1 || !isValidStage}
              ContainerProps={{
                mt: { xs: "1.8rem", sm: "0px" },
                flex: 1,
              }}
            />
          </Box>

          <Box
            display="flex"
            flex={1}
            mt={{ xs: "0px", sm: "1.5rem" }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <PhoneInput
              label="Telefone"
              value={phoneNumber}
              disabled
              ContainerProps={{
                flex: 1,
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: "0px", sm: "1rem" },
              }}
              error={!!phoneNumberError}
              errorText={phoneNumberError}
            />

            <DateInput
              label="Data Nascimento"
              value={birthDate}
              setValue={setBirthDate}
              disabled={currentStageNumber > 1 || !isValidStage}
              ContainerProps={{
                flex: 1,
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: "0px", sm: "1rem" },
              }}
              error={!!birthDateError}
              errorText={birthDateError}
            />

            <CpfInput
              label="CPF*"
              value={cpf}
              setValue={setCpf}
              disabled={!!userInfo?.cpf}
              ContainerProps={{
                flex: 1,
                width: "100%",
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: "0px", sm: "1rem" },
              }}
              error={!!cpfError}
              errorText={cpfError}
            />

            <GenderSelect
              value={gender}
              onChange={(e) => setGender(e.target.value as Gender)}
              disabled={currentStageNumber > 1 || !isValidStage}
              fullWidth
              ContainerProps={{
                flex: 1,
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: "0px", sm: "1rem" },
              }}
              error={!gender}
              helperText={!gender ? "Campo obrigatório" : ""}
            />

            <TextField
              label="Instagram (com o @)"
              value={instagramAccount}
              setValue={setInstagramAccount}
              disabled={
                (currentStageNumber > 1 || !isValidStage) &&
                !!userInfo?.instagramAccount
              }
              ContainerProps={{
                flex: 1,
                mt: { xs: "1.8rem", sm: "0px" },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      isOpen={isOpenInstagramTooltip}
                      onClose={toggleTooltip}
                      placement="top-end"
                      title="Caso não possua a rede social solicitada, informe que não tem. Não se preocupe caso não tenha, apenas queremos conhecer melhor você."
                    >
                      <Box
                        display="flex"
                        style={{ cursor: "pointer" }}
                        onClick={toggleTooltip}
                      >
                        <InfoIcon size={20} />
                      </Box>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box
            display={currentStageNumber <= 1 ? "flex" : "none"}
            flex={1}
            mt={{ xs: "0px", sm: "1.5rem" }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box
              flex={1}
              mr={{ xs: "0px", sm: "1rem" }}
              mt={{ xs: "1.8rem", sm: "0px" }}
            >
              <StateSelect
                value={state}
                setValue={setState}
                disabled={currentStageNumber > 1 || !isValidStage}
                error={!state}
                helperText={!state ? "Campo obrigatório" : ""}
              />
            </Box>

            <Box flex={1} mr={{ xs: "0px", sm: "1rem" }} mt={{ xs: "1.8rem", sm: "0px" }}>
              <CitySelect
                state={state}
                value={city}
                setValue={setCity}
                disabled={currentStageNumber > 1 || !isValidStage}
                error={!city}
                helperText={!city ? "Escolha uma cidade" : ""}
              />
            </Box>

            <TextField
              label="Região"
              value={region}
              disabled
              ContainerProps={{
                flex: 1,
                mt: { xs: "1.8rem", sm: "0px" },
              }}
            />
          </Box>

          <Box
            display={currentStageNumber > 1 ? "flex" : "none"}
            flex={1}
            mt={{ xs: "0px", sm: "1.5rem" }}
            flexDirection="column"
          >
            <PhoneInput
              label="Contato (Responsável)"
              value={phoneNumberResponsible}
              setValue={setPhoneNumberResponsible}
              ContainerProps={{
                width: "100%",
                mt: { xs: "1.8rem", sm: "0px" },
              }}
              error={!!phoneNumberResponsibleError}
              errorText={phoneNumberResponsibleError}
              disabled={
                !!userInfo?.phoneNumberResponsible &&
                !phoneNumberResponsibleError &&
                phoneNumberResponsible === userInfo?.phoneNumberResponsible
              }
            />

            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 0, sm: 1 }}
              mt={{ xs: 0, sm: "1rem" }}
            >
              <TextField
                label="Local de nascimento"
                value={birthPlace}
                setValue={setBirthPlace}
                disabled={!!userInfo?.birthPlace}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!birthPlace}
                helperText={!birthPlace ? "Campo obrigatório" : ""}
              />
              <TextField
                label="Estado civil"
                value={maritalStatus}
                setValue={setMaritalStatus}
                select
                disabled={!!userInfo?.maritalStatus}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!maritalStatus}
                helperText={!maritalStatus ? "Campo obrigatório" : ""}
              >
                {MARITAL_STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 0, sm: 1 }}
              mt={{ xs: 0, sm: "1rem" }}
            >
              <TextField
                label="Nome completo do pai"
                value={fatherName}
                setValue={setFatherName}
                disabled={!!userInfo?.fatherName?.trim()}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
              />
              <TextField
                label="Nome completo da mãe"
                value={motherName}
                setValue={setMotherName}
                disabled={!!userInfo?.motherName}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!motherName}
                helperText={!motherName ? "Campo obrigatório" : ""}
              />
            </Box>

            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 0, sm: 1 }}
              mt={{ xs: 0, sm: "1rem" }}
            >
              <TextField
                label="RG/RNE"
                value={rgRne}
                setValue={setRgRne}
                disabled={!!userInfo?.rgRne}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!rgRne}
                helperText={!rgRne ? "Campo obrigatório" : ""}
              />
              <TextField
                label="Órgão expedidor"
                value={rgIssuingAgency}
                setValue={setRgIssuingAgency}
                disabled={!!userInfo?.rgIssuingAgency}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!rgIssuingAgency}
                helperText={!rgIssuingAgency ? "Campo obrigatório" : ""}
              />
              <DateInput
                label="Data de expedição"
                value={rgIssueDate}
                setValue={setRgIssueDate}
                disabled={!!userInfo?.rgIssueDate}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!!rgIssueDateError || !rgIssueDate}
                errorText={
                  rgIssueDateError ||
                  (!rgIssueDate ? "Campo obrigatório" : "")
                }
              />
            </Box>

            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 0, sm: 1 }}
              alignItems={{ xs: "stretch", sm: "flex-start" }}
              mt={{ xs: 0, sm: "1rem" }}
            >
              <Box
                sx={{
                  width: { xs: "100%", sm: "25%" },
                  flexShrink: 0,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
              >
                <TextField
                  label="CEP"
                  value={cep}
                  setValue={setCep}
                  disabled={!!userInfo?.cep}
                  ContainerProps={{ width: "100%" }}
                  onlyNumbers
                  error={!cep || (!!cepLookupHint && !cepLookupLoading)}
                  helperText={
                    !cep
                      ? "Campo obrigatório"
                      : cepLookupHint ||
                        ((cep ?? "").replace(/\D/g, "").length < 8
                          ? "Digite os 8 dígitos para buscar endereço e bairro."
                          : "")
                  }
                  InputProps={{
                    endAdornment: cepLookupLoading ? (
                      <InputAdornment position="end">
                        <CircularProgress color="inherit" size={18} />
                      </InputAdornment>
                    ) : undefined,
                  }}
                />
              </Box>
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
              >
                <TextField
                  label="Endereço"
                  value={address}
                  setValue={setAddress}
                  disabled={!!userInfo?.address}
                  ContainerProps={{ width: "100%" }}
                  error={!address}
                  helperText={!address ? "Campo obrigatório" : ""}
                />
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 0, sm: 1 }}
              mt={{ xs: 0, sm: "1rem" }}
            >
              <TextField
                label="Número"
                value={numberAddress}
                setValue={setNumberAddress}
                disabled={!!userInfo?.numberAddress}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                onlyNumbers
                error={!numberAddress}
                helperText={!numberAddress ? "Campo obrigatório" : ""}
              />
              <TextField
                label="Bairro"
                value={neighborhood}
                setValue={setNeighborhood}
                disabled={!!userInfo?.neighborhood}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
                error={!neighborhood}
                helperText={!neighborhood ? "Campo obrigatório" : ""}
              />
              <TextField
                label="Complemento"
                value={complement}
                setValue={setComplement}
                disabled={!!userInfo?.complement}
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
              />
            </Box>

            <Box
              display="flex"
              flex={1}
              mt={{ xs: "0px", sm: "1rem" }}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <Box
                flex={1}
                mr={{ xs: "0px", sm: "1rem" }}
                mt={{ xs: "1.8rem", sm: "0px" }}
              >
                <StateSelect
                  value={state}
                  setValue={setState}
                  disabled={currentStageNumber > 1 || !isValidStage}
                  error={!state}
                  helperText={!state ? "Campo obrigatório" : ""}
                />
              </Box>

              <Box
                flex={1}
                mr={{ xs: "0px", sm: "1rem" }}
                mt={{ xs: "1.8rem", sm: "0px" }}
              >
                <CitySelect
                  state={state}
                  value={city}
                  setValue={setCity}
                  disabled={currentStageNumber > 1 || !isValidStage}
                  error={!city}
                  helperText={!city ? "Escolha uma cidade" : ""}
                />
              </Box>

              <TextField
                label="Região"
                value={region}
                disabled
                ContainerProps={{
                  flex: 1,
                  mt: { xs: "1.8rem", sm: "0px" },
                }}
              />
            </Box>
          </Box>

          <Box
            display="flex"
            flex={1}
            mt={{ xs: "0px", sm: "1.5rem" }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              label="Principal atividade de obra"
              value={selectedProfessionName}
              setValue={setSelectedProfessionName}
              select
              disabled={
                currentStageNumber > 1 || !isValidStage
              }
              ContainerProps={{
                mr: { xs: "0px", sm: "1rem" },
                mt: { xs: "1.8rem", sm: "0px" },
                flex: 1,
              }}
              sx={{
                "& .MuiSelect-select": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              }}
            >
              {professionSelectOptions.map((occupation) => (
                <MenuItem key={occupation.id} value={occupation.name}>
                  {occupation.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Tempo de profissão"
              value={timeOfProfession}
              setValue={setTimeOfProfession}
              select
              disabled={currentStageNumber > 1 || !isValidStage}
              ContainerProps={{
                mt: { xs: "1.8rem", sm: "0px" },
                flex: 1,
              }}
            >
              {TIME_OF_PROFESSION_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Box
            display={currentStageNumber > 1 ? "flex" : "none"}
            flex={1}
            flexWrap={{ xs: "wrap", sm: "nowrap" }}
            mt={{ xs: "0px", sm: "1.5rem" }}
            gap={{ xs: 0, sm: 1 }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              label="Tamanho Camisa"
              value={shirtSize}
              setValue={setShirtSize}
              disabled={!!userInfo?.shirtSize}
              ContainerProps={{
                flex: 1,
                minWidth: { xs: "100%", sm: 0 },
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: 0, sm: 1 },
              }}
              error={!shirtSize}
              helperText={!shirtSize ? "Campo obrigatório" : ""}
            />
            <TextField
              label="Tamanho Calçado"
              value={shoeSize}
              setValue={setShoeSize}
              disabled={!!userInfo?.shoeSize}
              ContainerProps={{
                flex: 1,
                minWidth: { xs: "100%", sm: 0 },
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: 0, sm: 1 },
              }}
              error={!shoeSize}
              helperText={!shoeSize ? "Campo obrigatório" : ""}
            />
            <TextField
              label="Tamanho Calça"
              value={pantsSize}
              setValue={setPantsSize}
              disabled={!!userInfo?.pantsSize}
              ContainerProps={{
                flex: 1,
                minWidth: { xs: "100%", sm: 0 },
                mt: { xs: "1.8rem", sm: "0px" },
                mr: { xs: 0, sm: 1 },
              }}
              error={!pantsSize}
              helperText={!pantsSize ? "Campo obrigatório" : ""}
            />
            <TextField
              label="Tamanho Luva"
              value={gloveSize}
              setValue={setGloveSize}
              disabled={!!userInfo?.gloveSize}
              ContainerProps={{
                flex: 1,
                minWidth: { xs: "100%", sm: 0 },
                mt: { xs: "1.8rem", sm: "0px" },
              }}
              error={!gloveSize}
              helperText={!gloveSize ? "Campo obrigatório" : ""}
            />
          </Box>

          <Box
            display={currentStageNumber > 1 ? "flex" : "none"}
            flex={1}
            mt={{ xs: "0px", sm: "1.5rem" }}
            flexDirection={{ xs: "column", sm: "row" }}
            gap={{ xs: 0, sm: 2 }}
            alignItems={{ xs: "stretch", sm: "flex-start" }}
          >
            <Box
              display="flex"
              flexDirection="column"
              flex={1}
              mt={{ xs: "1.8rem", sm: "0px" }}
            >
              <FileInput
                disabled={!!userInfo?.addressProofUrl}
                variant="image"
                getSignedUrlService={() =>
                  getUploadPostAdvanceDocumentUrl("address-proof")
                }
                onUploaded={(url) => setAddressProofUrl(url)}
                component={
                  <Button variant="outlined" fullWidth>
                    {addressProofUrl
                      ? "Comprovante enviado"
                      : "Enviar comprovante de endereço"}
                  </Button>
                }
              />
              {!addressProofUrl && (
                <FormHelperText error sx={{ mx: 0, mt: 0.5 }}>
                  Campo obrigatório
                </FormHelperText>
              )}
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              flex={1}
              mt={{ xs: "1.8rem", sm: "0px" }}
            >
              <FileInput
                disabled={!!userInfo?.identityDocumentUrl}
                variant="image"
                getSignedUrlService={() =>
                  getUploadPostAdvanceDocumentUrl("identity-document")
                }
                onUploaded={(url) => setIdentityDocumentUrl(url)}
                component={
                  <Button variant="outlined" fullWidth>
                    {identityDocumentUrl
                      ? "Documento enviado"
                      : "Enviar RG/Habilitação"}
                  </Button>
                }
              />
              {!identityDocumentUrl && (
                <FormHelperText error sx={{ mx: 0, mt: 0.5 }}>
                  Campo obrigatório
                </FormHelperText>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box mt="1.5rem" justifyContent="end" display="flex">
        <>
          <Button
            onClick={onPressCancel}
            size="small"
            variant="outlined"
            fullWidth={false}
            disabled={!hasChanges}
            style={{
              minWidth: "10%",
              padding: "0.5rem",
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={onPressSave}
            disabled={!hasChanges}
            size="small"
            fullWidth={false}
            style={{
              minWidth: "10%",
              padding: "0.5rem",
              marginLeft: "1rem",
            }}
          >
            Salvar
          </Button>
        </>

        <Dialog
          isOpen={showConfirmChangesDialog}
          text={`Atenção! Deseja realmente prosseguir com as alterações?`}
          onConfirm={onSaveChanges}
          onClose={toggleConfirmDialog}
          isLoading={isLoading}
          confirmButtonText={"Salvar Alterações"}
        />

        <Dialog
          isOpen={showChangesDialog}
          text={`Atenção! Ao sair sem salvar, todas as modificações serão perdidas.\nDeseja descartas as alterações?`}
          onConfirm={onCancelChanges}
          confirmButtonText="Confirmar"
          onClose={toggleChangesDialog}
        />

        <Dialog
          isOpen={showChangesSavedDialog}
          icon={<CircleCheck />}
          text="Alterações salvas com sucesso!"
          onConfirm={toggleChangesSavedDialog}
        />
      </Box>
    </CardWithShadow>
  );
}
